import React from 'react';
import styled from 'styled-components';
import CONFIG from '../../../config';

const LoaderDiv = styled.div`
  position: relative;
  height: 100vh;
  background: ${(props) => (props.darkTheme ? props.theme.pageBg : '#fff')};
`;

export const LoaderImg = styled.img`
  position: absolute;
  width: 180px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (min-width: 768px) {
    width: 240px;
  }
  @media (min-width: 1200px) {
    width: 280px;
  }
  @media (min-width: 2000px) {
    width: 300px;
  }
`;

const ButtonLoaderDiv = styled.div`
  float: right;
  height: 16px;
  margin-right: 4px;
`;

const ButtonLoaderGif = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 3px solid ${({ darkTheme }) => (darkTheme ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)')};
  border-radius: 50%;
  border-top-color: ${({ darkTheme }) => (darkTheme ? 'var(--inputTxtColor)' : '#fff')};
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;

const TestCaseLoaderGif = styled(ButtonLoaderGif)`
  border: ${(props) => (props.borderColor ? `3px solid ${props.borderColor}` : '3px solid #2d4ef5')};
  border-top-color: #fafafa;
`;

const ViewRepliesLoaderDiv = styled.div`
  position: relative;
  top: 20px;
  left: 150px;
  margin-bottom: 20px;
`;

const ViewRepliesLoaderGif = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 3px solid #2d4ef5;
  border-top-color: #fafafa;
  border-radius: 50%;
  animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;

const SpinnerLoaderDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;

const SpinnerLoaderSpan = styled.span`
  display: inline-block;
  width: 35px;
  height: 35px;
  border: 3px solid var(--primary);
  border-radius: 50%;
  border-top-color: #fff;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;

const cloudFront = CONFIG.cloudFront;
export const Loader = ({ style, darkTheme }) => (
  <LoaderDiv style={style} darkTheme={darkTheme}>
    <LoaderImg src={darkTheme ? cloudFront + '/Assets/SiteLoaderDark.gif' : cloudFront + '/Assets/SiteLoader.gif'} />
  </LoaderDiv>
);

export const ButtonLoader = ({ style, styleGif, darkTheme }) => (
  <ButtonLoaderDiv style={style}>
    <ButtonLoaderGif style={styleGif} darkTheme={darkTheme} />
  </ButtonLoaderDiv>
);

export const TestCaseLoader = ({ style, styleGif, borderColor }) => (
  <ButtonLoaderDiv style={style}>
    <TestCaseLoaderGif borderColor={borderColor} style={styleGif} />
  </ButtonLoaderDiv>
);

export const ViewRepliesLoader = ({ style }) => (
  <ViewRepliesLoaderDiv style={style}>
    <ViewRepliesLoaderGif />
  </ViewRepliesLoaderDiv>
);

export const SpinnerLoader = ({ style, spinnerStyle }) => (
  <SpinnerLoaderDiv style={style}>
    <SpinnerLoaderSpan style={spinnerStyle} />
  </SpinnerLoaderDiv>
);
